<div class="note-dialog">
  <button mat-icon-button type="button" class="close-btn" [attr.aria-label]="'common.close' | translate" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="dialog-icon">
    <mat-icon>description</mat-icon>
  </div>

  <h2 mat-dialog-title class="dialog-title">
    {{ 'labor_contract_standardize.note_dialog.title' | translate }}
  </h2>

  <div class="note-list">
    <div *ngIf="isLoading" class="note-loading">
      <mat-spinner diameter="36"></mat-spinner>
    </div>

    <ng-container *ngIf="!isLoading">
      <div class="note-item" *ngFor="let note of notes">
        {{ note }}
      </div>

      <div class="note-empty" *ngIf="!notes.length && !errorMessage">
        {{ 'common.no_data' | translate }}
      </div>

      <div class="note-error" *ngIf="errorMessage">
        {{ errorMessage | translate }}
      </div>
    </ng-container>
  </div>

  <mat-dialog-actions class="dialog-footer">
    <button mat-stroked-button color="primary" type="button" (click)="onCancel()">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{ 'common.close' | translate }}
    </button>
  </mat-dialog-actions>
</div>
